import { Injectable } from '@angular/core';

import { ApiService, AuthService, UserService, LogService, BillingService, Plan, Coupon, Register } from './../shared';

@Injectable()
export class RegisterService {
  holderName: string = '';
  card: string = '';
  expiration: string = '';
  month: number = -1;
  year: number = -1;
  cvc: string = '';
  postalCode: string = '';

  holderNameError: string = '';
  postalCodeError: string = '';

  coupon: string = '';
  freeAccount: boolean = false;
  costMultiplier: number = 1;

  accountType: string = 'Basic';
  billingPeriod: string = 'Monthly';
  cost: string = '';
  plan: string = 'Basic';

  couponValid: boolean = false;
  couponError: string = '';

  stripeStatus: number = 0;
  stripeResponse: any = null;
  errors = {
    holderName: '',
    card: '',
    expiration: '',
    cvc: '',
    postalCode: '',
    register: '', 
    cardRegister: '', 
    emailRegister: ''
  };

  plans: Plan[] = new Array<Plan>();
  displayThanks: boolean = false;
  displayAccountDetails: boolean = true;
  loaderOn: boolean = false;

  constructor(private apiService: ApiService, private authService: AuthService, private userService: UserService, private logger: LogService, private billing: BillingService) {
    this.getPlans();
  }

  getPlans() {
    this.billing.getPlans().then((plans: Plan[]) => {
      this.plans = plans;
    });
  }

  updateCost() {
    let cost = '';
    if (this.accountType === 'Premium') {
      if (this.billingPeriod === 'Monthly') {
        cost = `You will be charged $${(49 * this.costMultiplier).toFixed(2)} in 14 days`;
        this.plan = 'monthly-premium';
      } else {
        cost = `You will be charged $${(488 * this.costMultiplier).toFixed(2)} in 14 days`;
        this.plan = 'yearly-premium';
      }
    } else if (this.accountType === 'Professional') {
      if (this.billingPeriod === 'Monthly') {
        cost = `You will be charged $${(99 * this.costMultiplier).toFixed(2)} in 14 days`;
        this.plan = 'monthly-professional';
      } else {
        cost = `You will be charged $${(988 * this.costMultiplier).toFixed(2)} in 14 days`;
        this.plan = 'yearly-professional';
      }
    } else if (this.accountType === 'Enterprise6') {
      if (this.billingPeriod === 'Monthly') {
        cost = `You will be charged $${(149 * this.costMultiplier).toFixed(2)}`;
        this.plan = 'price_1HUDlXBI16lWsbHUpazF2axJ';
      } else {
        cost = `You will be charged $${(1488 * this.costMultiplier).toFixed(2)}`;
        this.plan = 'price_1HrW7lBI16lWsbHUsNT327Sp'; 
      }
    } else if (this.accountType === 'Enterprise12') {
      if (this.billingPeriod === 'Monthly') {
        cost = `You will be charged $${(199 * this.costMultiplier).toFixed(2)}`;
        this.plan = 'price_1HUDrpBI16lWsbHUEcy8QqRp';
      } else {
        cost = `You will be charged $${(1988 * this.costMultiplier).toFixed(2)}`;
        this.plan = 'price_1HtzNJBI16lWsbHUF6DRNf0X'; 
      }
    } else if (this.accountType === 'Enterprise18') {
      if (this.billingPeriod === 'Monthly') {
        cost = `You will be charged $${(249 * this.costMultiplier).toFixed(2)}`;
        this.plan = 'price_1HUDwiBI16lWsbHUJUXFNMp2';
      } else{
        cost = `You will be charged $${(2488 * this.costMultiplier).toFixed(2)}`;
        this.plan = 'price_1HtzKUBI16lWsbHU4gyZlwmJ'; 
      }
    } else if (this.accountType === 'API500') {
      this.billingPeriod = 'Monthly';
      cost = `You will be charged $${(330 * this.costMultiplier).toFixed(2)}`;
      this.plan = 'price_1KDzaGCAIBqfWZikF50UOobO';
    } else if (this.accountType === 'API1500') {
      this.billingPeriod = 'Monthly';
      cost = `You will be charged $${(550 * this.costMultiplier).toFixed(2)}`;
      this.plan = 'price_1KDzdlCAIBqfWZikTr54Oj54';
    } else if (this.accountType === 'API4000') {
      this.billingPeriod = 'Monthly';
      cost = `You will be charged $${(1000 * this.costMultiplier).toFixed(2)}`;
      this.plan = 'price_1KDzh3CAIBqfWZikkmKsljAm';
    } else if (this.accountType === 'API15000') {
      this.billingPeriod = 'Monthly';
      cost = `You will be charged $${(1990 * this.costMultiplier).toFixed(2)}`;
      this.plan = 'price_1KDzicCAIBqfWZikm7knIDYs';
    } else if (this.accountType === 'API50000') {
      this.billingPeriod = 'Monthly';
      cost = `You will be charged $${(3600 * this.costMultiplier).toFixed(2)}`;
      this.plan = 'price_1KDzlWCAIBqfWZikOzC01OKm';
    } else if (this.accountType === 'API150000') {
      this.billingPeriod = 'Monthly';
      cost = `You will be charged $${(4900 * this.costMultiplier).toFixed(2)}`;
      this.plan = 'price_1KDzoOCAIBqfWZik4wgvO1ZZ';
    }

    this.cost = this.freeAccount ? 'FREE ACCOUNT' : cost;
  }

  checkCoupon() {
    this.couponValid = false;
    this.couponError = '';

    if (this.validateCoupon()) {
      this.logger.log('register.service', 'checkCoupon', 'before call');
      this.callCheckCoupon();
    }
  }

  getToken() {
    this.expirationMasking();
    this.stripeStatus = 0;

    if (this.validateCard() && this.validateExpiration() && this.validateCVC()) {
      this.logger.log('register.service', 'getToken', 'before call');
      this.callGetToken();
    }
  }

  // **** 
  getTokenForCheckCard(): Promise<any> {
    let model = {
      name: this.holderName.trim(),
      number: +this.card,
      exp_month: this.month,
      exp_year: this.year,
      cvc: +this.cvc,
      address_zip: this.postalCode.trim()
    };

    return this.billing.createToken(model);
  }

  tokenResponse(status: number, response: any) {
    this.stripeStatus = status;
    this.stripeResponse = response;
    if (this.stripeStatus === 200) {
      //this.cardOkay = true;
    } else {
      this.stripeError(response.error);
      //this.cardOkay = false;
    }
  }

  stripeError(error: any) {
    try {
      if (error.param === 'number') {
        this.errors.card = error.message;
      } else if (error.param === 'exp_year' || error.param === 'exp_month') {
        this.errors.expiration = error.message;
      } else if (error.param === 'name') {
        this.errors.holderName = error.message;
      } else if (error.param === 'address_zip') {
        this.errors.holderName = error.message;
      }
    } catch (ex) {
      this.errors.register = 'Card Invalid';
    }
  }

  // ****

  validateCoupon(): boolean {
    if (this.coupon.length === 0 || this.coupon.length > 256) {
      return false;
    }
    // this.errors.coupon = '';
    return true;
  }

  validateCard(): boolean {
    this.stripeStatus = 0;
    if (this.card.length !== 13 && this.card.length !== 14 && this.card.length !== 15 && this.card.length !== 16 && this.card.length !== 17 && this.card.length !== 18 && this.card.length !== 19) {
      return false;
    }

    this.errors.card = '';
    return true;
  }

  validateExpiration(): boolean {
    this.stripeStatus = 0;
    try {
      let exp = this.expiration.split('/');
      this.month = +exp[0];
      this.year = +exp[1];

      if (this.month <= 0 || this.month >= 13) {
        return false;
      }

      if (this.year <= 0 || this.year >= 100) {
        return false;
      }
    } catch (ex) {
      return false;
    }

    this.errors.expiration = '';
    return true;
  }

  validateCVC(): boolean {
    this.stripeStatus = 0;
    if (this.cvc.length !== 3 && this.cvc.length !== 4) {
      return false;
    }
    this.errors.cvc = '';
    return true;
  }

  validateHolderName(): boolean {
    let name = this.holderName.trim();
    if (name.length === 0 || name.length > 256) {
      this.holderNameError = 'Invalid Card Holder Name';
      return false;
    } else {
      this.holderNameError = '';
      return true;
    }
  }

  validatePostalCode(): boolean {
    let code = this.postalCode.trim();
    if (code.length === 0 || code.length > 256) {
      this.postalCodeError = 'Invalid Postal Code';
      return false;
    } else {
      this.postalCodeError = '';
      return true;
    }
  }

  callCheckCoupon() {
    this.billing.checkCoupon(this.coupon).then((coupon: Coupon) => {
      if (coupon.percentOff == 100) {
        // free account
        this.cost = 'FREE ACCOUNT';
        this.freeAccount = true;
        this.couponValid = true;
      } else if (coupon.percentOff !== 0 && coupon.percentOff) {
        this.costMultiplier = 1 - (coupon.percentOff / 100);
        this.couponValid = true;
      } else {
        this.couponError = 'Invalid Coupon';
        this.couponValid = false;
      }
    }).catch((err) => {
      // make stuff happen
      this.couponError = 'Invalid Coupon';
      this.couponValid = false;
    });
  }

  callGetToken() {
    let model = {
      number: +this.card,
      exp_month: this.month,
      exp_year: this.year,
      cvc: +this.cvc
    };
    this.billing.createToken(model).then((response) => {
      this.stripeResponseHandler(200, response);
    }).catch((err) => {
      this.stripeResponseHandler(400, err);
    });
  }

  stripeResponseHandler(status: number, response: any) {
    this.stripeStatus = status;
    this.stripeResponse = response;
  }

  registerProcess(model: Register) {
    this.errors.register = '';
    this.loaderOn = true;

    this.getToken();

    this.getTokenForCheckCard()
    .then((response) => {
      //this.tokenResponse(200, response);
      this.billing.createCustomer(model.email, response.id)   // ** stripeResponse.id
      .then(customer => {
        this.registerWithCognito(model);
        this.loaderOn = false;
      }).catch((err) => {
        this.cardUpdateFailure(err);
        this.loaderOn = false;
      });
    })
    .catch((err) => {
      this.tokenResponse(400, err);
      this.errors.register = err.message;
      this.loaderOn = false;
    });
  }

  registerWithCognito(model: Register) {
    this.logger.log('register.service', 'register before auth', model);
    this.errors.register = '';

    this.authService.register(model)
    .then(result => this.handleRegistration(model, result))
    .catch(err => this.handleRegistrationError(err));

  }

  handleRegistration(model: Register, result: any) {
    this.logger.log('register.service', 'handleRegistration result', result);
    let cognitoUser = result.user;

    this.displayAccountDetails = false;
    this.displayThanks = true;
    // localStorage.setItem('email', email);
    // localStorage.setItem('password', password);

    this.registerCustomer(model, this.plan, this.coupon);
  }

  // ****
  updateCard(model: Register) {
    this.expirationMasking();
    this.errors.register = '';
    //this.errors.cardRegister = '';
    //this.loaderOn = true;
    return new Promise((resolve, reject) => {
      var result = 4;
      if (this.validateHolderName() && this.validateCard() && this.validateExpiration() && this.validateCVC() && this.validatePostalCode()) {
        this.logger.log('update-card.service', 'getToken', 'before call');
        this.getTokenForCheckCard().then((response) => {
          this.tokenResponse(200, response);
          this.callUpdateCard(model);
          result = 3;
          resolve(result);
        }).catch((err) => {
          //this.loaderOn = false;
          this.tokenResponse(400, err);
          this.errors.register = err.message;
          result = 4;
          reject(result);
        });
        //this.updateCardAttempted = true;
      } else {
        // card is not validated, do not create token
        //this.cardOkay = false;
        //this.loaderOn = false;
        this.errors.register = "Invalid card";
        //this.updateCardAttempted = true;
        result = 4;
        reject(result);
      }
    })
  }

  callUpdateCard(model: Register) {
    this.billing.createCustomer(model.email, this.stripeResponse.id)
    .then(customer => {
      this.cardUpdateSuccess(customer);
      //this.loaderOn = false;
    }).catch((err) => {
      this.cardUpdateFailure(err);
      //this.loaderOn = false;
    });
  }

  cardUpdateSuccess(customer: any) {
    //this.app.setIsCustomer('stripeId'); // just to set it to true
    //this.app.setCustomer(customer);
    this.getCustomer();
    this.errors.register = 'Success';
    //this.showEditCard = false;
  }

  cardUpdateFailure(error: any) {
    this.logger.log('update-card.service', 'cardUpdateFailure', error);
    try {
      this.errors.register = error.data.details.message;
    } catch (ex) {
      this.errors.register = 'Something went wrong';
    }
  }

  getCustomer() {
    this.billing.getCustomer().then(customer => {
      this.logger.log('update-card.service', 'getCustomer customer', customer);
      try {
        //this.lastFour = customer.sources[0].lastFour;
        //this.exp = `${customer.sources[0].expMonth}/${customer.sources[0].expYear}`;
      } catch (ex) {
        //this.lastFour = '';
        //this.exp = '';
      }
    }).catch(err => {
      this.logger.log('update-card.service', 'getCustomer error', err);
    });
  }

  //****

  registerCustomer(model: Register, planId: string, coupon: string) {
    let stripeId = '';
    let couponId = '';

    if (this.stripeStatus === 200 && this.stripeResponse !== null) {
      stripeId = this.stripeResponse.id;
    }

    if (this.couponError === '' && this.couponValid) {
      couponId = coupon; // only use the coupon if it is valid
    }

    model.token = stripeId;
    model.planId = planId;
    model.coupon = couponId;

    this.userService.createUser(model).then(result => {
      this.logger.log('register.service', 'registerCustomer result', result);
      this.apiService.destroy();
    }).catch(err => {
      this.logger.log('register.service', 'registerCustomer error', err);
    });
  }

  handleRegistrationError(error: any) {
    this.logger.log('register.service', 'handleRegistrationError', error);
    if (error = 'Error: User already exists') {
      this.errors.register = 'Email already in use';
    } else {
      this.errors.register = error;
    }

    // ****
    //this.errors.register = 'handleRegistrationError';
  }

  expirationMasking() {
    if (this.expiration.match(/^\d{2}$/) !== null) {
      this.expiration = this.expiration + '/';
    }
  }

  numeralInputMasking(event) {
    let e = event || window.event;
    let key = event.keyCode || e.which;

    if ((key < 48 || key > 57) && key !== 37 && key !== 38 && key !== 39 && key !== 40 && key !== 46 && key !== 8 && key !== 35) {
      e.preventDefault();
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/register/register.service.ts